<template>
  <div class="crear-version screen page formActions b-soft">
    <div class="grid">
      <formVersion 
      v-bind:prop_cotizacion="cotizacion" 
      v-on:actionChange="onActionChange" />
      <GetFooter />
    </div>
  </div>
</template>

<script>
import formVersion from '@/components/form-version.vue'
import GetFooter from '@/components/footer.vue'
import { db, auth } from '@/firebase'
export default {
  name: 'app',
  components: {
    formVersion,
    GetFooter
  },
  data() {
    return {
      cotizacion: {},
      action_state: true
    }
  },
  firestore () {
    return {
      cotizacion: db.collection('cotizaciones').doc(this.$route.params.id),
    }
  },
  methods: {
    onActionChange(getactionChange){
      this.action_state = getactionChange
    }
  },
  beforeRouteLeave (to, from, next) {
    if(this.action_state){
      next()
    }else{
      const answer = window.confirm('¿Estás Seguro? Se perderá la información que se haya modificado')
      if(answer){
        next()
      } else {
        next(false)
      }
    }
  }
}
</script>